import getInboxReminderDraft from '../selectors/getInboxReminderDraft';
import isSendOptionToAllAttendees from '../utils/isSendOptionToAllAttendees';
import emailRemindersStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    setDraftInboxReminder,
    setDraftInboxReminderMessage,
    setDraftInboxReminderOffset,
    setDraftInboxReminderSendOption,
} from '../actions/draftInboxReminderActions';

mutator(setDraftInboxReminder, actionMessage => {
    emailRemindersStore.draftReminder = actionMessage.inboxReminder;
});

mutator(setDraftInboxReminderOffset, actionMessage => {
    getInboxReminderDraft().ReminderOffset = actionMessage.reminderOffset;
});

mutator(setDraftInboxReminderSendOption, actionMessage => {
    getInboxReminderDraft().SendOption = actionMessage.sendOption;
    getInboxReminderDraft().IsOrganizerReminder = isSendOptionToAllAttendees(
        actionMessage.sendOption
    );
});

mutator(setDraftInboxReminderMessage, actionMessage => {
    getInboxReminderDraft().Message = actionMessage.message;
});
